import ScrollReveal from "components/common/ScrollReveal";

const PageHero = ({ title, subtitle, body, image }) => {
    return (
        <section className="relative pt-28 md:pt-32 pb-16 md:pb-20 overflow-hidden gradient-mesh">
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/5 rounded-full blur-3xl" />
            </div>

            <div className="container relative">
                <div className="max-w-4xl mx-auto text-center">
                    {image && (
                        <ScrollReveal variant="scale">
                            <div className="w-full max-w-xs md:max-w-sm mx-auto mb-8">
                                <img
                                    src={image}
                                    alt=""
                                    className="w-full h-auto"
                                />
                            </div>
                        </ScrollReveal>
                    )}

                    {subtitle && (
                        <ScrollReveal variant="up" delay={100}>
                            <span className="section-eyebrow">{subtitle}</span>
                        </ScrollReveal>
                    )}

                    {title && (
                        <ScrollReveal variant="up" delay={150}>
                            <h1 className="section-title text-primary mb-6">
                                {title}
                            </h1>
                        </ScrollReveal>
                    )}

                    {body && (
                        <ScrollReveal variant="up" delay={200}>
                            <div className="text-base md:text-lg text-secondary/80 leading-relaxed max-w-2xl mx-auto">
                                {body}
                            </div>
                        </ScrollReveal>
                    )}
                </div>
            </div>

            <div className="absolute bottom-0 left-0 right-0 overflow-hidden leading-none">
                <svg
                    className="w-full h-8 md:h-12 text-white"
                    viewBox="0 0 1440 48"
                    fill="none"
                    preserveAspectRatio="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M0 48h720C360 48 360 0 0 0v48zm720 0h720V0C1080 48 1080 48 720 48z"
                        fill="currentColor"
                    />
                </svg>
            </div>
        </section>
    );
};

export default PageHero;
